export default __webpack_public_path__ + "static/media/Carrier Stand (2).783d2417.jpg";